import React from "react";
import MultiSelectDropdown from "../../../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/averageNumberOfVisitsPerClientSagas";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import LoadingAnimation from "../../../../../../components/loadingAnimation/loadingAnimation";
const CategoriesFilter = ({ options = [], selected = [], action, loader, name }) => {
  const dispatch = useDispatch();
  return (
    <div className="select-box-no-width">
      <p>{name}</p>
      {!loader ? (
        <MultiSelectDropdown
          filterType="Custom Range"
          options={options}
          includeFilter={true}
          enableOnly={true}
          height={324}
          includeSelectAll={true}
          numberDisplayed={0}
          selectedFilters={selected}
          enableDefaultSelected={true}
          haveOnSelectChange={false}
          updateLocations={(data) => dispatch(actionCreators[action](data))}
        />
      ) : (
        <LoadingAnimation uiLoader />
      )}
    </div>
  );
};

export default CategoriesFilter;

CategoriesFilter.propTypes = {
  options: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  action: PropTypes.string.isRequired,
  loader: PropTypes.bool.isRequired,
  name: PropTypes.string
};
